import { Form, Input } from 'antd'
import DocumentUpload from 'app/components/Core/Document/Upload'
import * as React from 'react'
import { useIntl } from 'react-intl'

import { ComplainPayload } from './Modal'

type Props = {
  setPayload?: (payload: ComplainPayload) => void
  invoice: IInvoice
}

const DamageInvoiceComplaint: React.FC<Props> = ({ setPayload, invoice }) => {
  const { formatMessage } = useIntl()

  return (
    <div className="fade-in-slow">
      <h5 className="text-black">{formatMessage({ id: 'invoice.modal.complaint.form.title' })}</h5>
      <p>{formatMessage({ id: 'invoice.modal.complaint.form.description.damage' })}</p>

      <Form layout="vertical">
        <Form.Item
          label={formatMessage({ id: 'invoice.modal.complaint.form.annotation.label' })}
          name="description">
          <Input.TextArea
            placeholder={formatMessage({
              id: 'invoice.modal.complaint.form.annotation.placeholder'
            })}
            rows={4}
            onChange={(e) => setPayload?.({ description: e.target.value })}
          />
        </Form.Item>
      </Form>

      <div className="mt-2">
        <DocumentUpload
          className="full-width"
          props={{
            model_id: invoice.rental_id,
            document_type: 'claim',
            model_type: 'Rental'
          }}>
          <p className="text-center text-gray my-3 p-1">
            {formatMessage({ id: 'invoice.modal.complaint.document.upload.damage' })}
          </p>
        </DocumentUpload>
      </div>
    </div>
  )
}

export default DamageInvoiceComplaint
